import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  Input,
  OnDestroy,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';

// A page that doesn't require signing in can render before the user's roles load, so check them again whenever the
// user state changes.
const USER_STATE_EVENTS = [
  'risevision.user.authorized',
  'risevision.user.updated',
  'risevision.user.signedOut',
];

@Directive({
  selector: '[requireRole]',
  standalone: false,
})
export class RequireRoleDirective implements OnDestroy {
  rendered = false;

  private roles: string | undefined;
  // Optional so a test's partial broadcaster stand-in doesn't break every view using the directive.
  private userStateSubscription: Subscription | undefined = inject(
    BroadcasterService,
  ).subscribe?.((event: string) => {
    if (USER_STATE_EVENTS.includes(event)) {
      this.update();
    }
  });

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private userStateService: UserStateService,
  ) {}

  @Input() set requireRole(roles: string | undefined) {
    this.roles = roles;
    this.update();
  }

  ngOnDestroy() {
    this.userStateSubscription?.unsubscribe();
  }

  private update() {
    const permitted = this.userStateService.hasPermission(this.roles);

    if (permitted && !this.rendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);

      this.rendered = true;
    } else if (!permitted && this.rendered) {
      this.viewContainerRef.clear();

      this.rendered = false;
    }
  }
}
